import { Flex } from 'antd'
import { useParams } from 'react-router-dom'

import { useIdentityServiceGetProfileEndpoint } from 'src/api/queries'
import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { UserGeneralCard, UserRolesCard } from '../components'
import { getFullName } from '../utils'

export const UsersEditPage = () => {
  const { id } = useParams()
  const { t } = useLocales()

  const { data } = useIdentityServiceGetProfileEndpoint(
    {
      id: String(id)
    },
    [id],
    { enabled: !!id }
  )

  const breadcrumbItems = [
    {
      title: t('menu.users'),
      path: paths.users.root
    },
    ...(data
      ? [
          {
            title: getFullName(data?.lastName, data?.firstName)
          }
        ]
      : [])
  ]

  return (
    <PageBreadcrumbs
      items={breadcrumbItems}
      title={getFullName(data?.lastName, data?.firstName)}
    >
      <Flex vertical gap={24}>
        <UserGeneralCard id={id} data={data} />
        <UserRolesCard id={id} />
      </Flex>
    </PageBreadcrumbs>
  )
}
